module.exports = __webpack_public_path__ + "img/Weapon_171.d625d840.png";